

import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

import ReactEcharts from "echarts-for-react";

import 'primereact/resources/themes/lara-light-indigo/theme.css';   // theme
import 'primereact/resources/primereact.css';

import SchoolDistBannerImg from "../../assets/images/school_dist_banner.jpg"
import InterviewImg from "../../assets/images/interview.png"

// import HorizontalStackBars from "../components/common/horizontalstackbars";
import HorizontalStackBars from "../../components/common/horizontalstackbars/horizontalstackbar";
import LoaderContainer from "../../components/LoaderContainer/LoaderContainer";
import { convertIntoCommaSeperated } from "../../utils";
import { formatNumber } from "./enrollment.component";
import { useDispatch, useSelector } from "react-redux";
import { fetchStudentCounselorRatio, fetchStudentTeacherRatio, fetchTeacherFTE, fetchTotal_Teacher_FTE } from "../../redux/slices/enrollment";




export default function StudentCharacteristics() {
    const [screenWidth, setScreenWidth] = useState(0);
    
    const Total_Teacher_FTE = useSelector(state => state.enrollment.Total_Teacher_FTE);
    const Total_Teacher_FTEloading = useSelector(state => state.enrollment.Total_Teacher_FTEloading);

    const TeacherFTEdata = useSelector(state => state.enrollment.TeacherFTE);
    const TeacherFTEloadingdata = useSelector(state => state.enrollment.TeacherFTEloading)

    const StudentTeacherRatioloadingdata = useSelector(state => state.enrollment.StudentTeacherRatioloading)
    const StudentTeacherRatiodata = useSelector(state => state.enrollment.StudentTeacherRatio);

    const StudentCounselorRatioloadingdata = useSelector(state => state.enrollment.StudentCounselorRatioloading)
    const StudentCounselorRatiodata = useSelector(state => state.enrollment.StudentCounselorRatio);

    const appliedfilter = useSelector(state => state.filter.appliedFilters);       

    const TeacherRatio = StudentTeacherRatiodata[0]?.VALUE
    const CounselorRatio = StudentCounselorRatiodata[0]?.VALUE
    const dispatch = useDispatch()

    useEffect(() => {
        const handleResize = () => {
            if (typeof window !== 'undefined') {
                const screenWidth = window.innerWidth;
                setScreenWidth(screenWidth);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const body = {
            "elasticQueryName": "Student_Employees_Tile",
            "filters": [{
      columnName: "SCHOOL_YEAR",
      columnValue: "2027",
      excludeKeyword: false,
    }],
            "dynamicColumns": [],
        }
        dispatch(fetchTotal_Teacher_FTE(body));
        dispatch(fetchTeacherFTE(body));
        dispatch(fetchStudentTeacherRatio(body));
        dispatch(fetchStudentCounselorRatio(body));



    }, []);

    // const SchoolDistrictEmployeesnew = {
    //     tooltip: {
    //         trigger: 'axis',
    //         backgroundColor: 'rgba(50,50,50,0.7)',
    //         borderColor: "#333",
    //         textStyle: {
    //             fontSize: 12,
    //             fontWeight: "normal",
    //             color: '#fff',
    //         },
    //         axisPointer: {
    //             type: 'shadow'
    //         },
    //         confine: true
    //     },
    //     grid: {
    //         left: '6%',
    //         bottom: '0%',
    //         top: "0%",
    //         right: '10%',
    //         height: '100%',
    //         containLabel: true
    //     },

    //     yAxis: [
    //         {
    //             type: 'category',
    //             position: "left",
    //             inverse: true,
    //             data: ['Elementary', 'Middle School', 'High School', 'Others'],
    //             axisLine: {
    //                 show: false,
    //                 lineStyle: {
    //                     color: '#E3E3E3'
    //                 }
    //             },
    //             axisLabel: {
    //                 color: '#fff',
    //                 fontSize: '10',
    //                 fontWeight: "normal",
    //                 position: 'insideLeft',
    //             },
    //             axisTick: {
    //                 show: false,
    //             },
    //         },
    //     ],

    //     xAxis: {
    //         show: false,
    //         inverse: false,
    //         min: 0,
    //         max: 3500,
    //         interval: 10,
    //     },

    //     series: [
    //         {
    //             label: {
    //                 normal: {
    //                     show: true,
    //                     position: "right",
    //                     fontSize: 10,
    //                     // padding: 10,
    //                     "formatter": function (params) {
    //                         return params.value.VALUE
    //                     },
    //                     "textStyle": {
    //                         "color": "#fff"
    //                     }
    //                 }
    //             },
    //             emphasis: {
    //                 focus: 'series'
    //             },
    //             data: [3031, 1088, 1329, 43],
    //             type: 'bar',
    //             barWidth: "80%",
    //             color: '#1F46AB',
    //             itemStyle: {
    //                 normal: {
    //                     barBorderRadius: [3, 3, 3, 3],
    //                     color: '#1F46AB',
    //                 }
    //             }

    //         }
    //     ]
    // };


    const order = [
        "Elementary",
        "High School",
        "Middle School",
        "Other"
    ];
    const sortedData = [...TeacherFTEdata]?.sort((a, b) => {
        return order?.indexOf(a.SCHOOL_TYPE) - order?.indexOf(b.SCHOOL_TYPE);
    });


    const SchoolDistrictEmployeesnew = {
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(50,50,50,0.7)',
            borderColor: "#333",
            textStyle: {
                fontSize: 12,
                fontWeight: "normal",
                color: '#fff',
            },
            axisPointer: {
                type: 'shadow'
            },
            formatter: (params) => {
                return `${params?.[0]?.marker} ${params?.[0]?.name}: ${params?.[0]?.value} (${params?.[0]?.data?.PERCENTAGE?.toFixed(1)}%)`
            },
            confine: true
        },
        grid: {
            left: '6%',
            bottom: '0%',
            top: "0%",
            right: '11%',
            height: '100%',
            containLabel: true
        },

        yAxis: [
            {
                type: 'category',
                position: "left",
                inverse: true,
                data: sortedData?.map(item => item.SCHOOL_TYPE),
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: '#E3E3E3'
                    }
                },
                axisLabel: {
                    color: '#fff',
                    fontSize: '10',
                    fontWeight: "normal",
                    position: 'insideLeft',
                },
                axisTick: {
                    show: false,
                },
            },
        ],

        xAxis: {
            show: false,
            // inverse: false,
            // min: 0,
            // max: 5000,
            // interval: 5,
            axisLabel: {
                show: true
            }
        },

        series: [
            {
                label: {
                    normal: {
                        show: true,
                        position: "right",
                        fontSize: 10,
                        // padding: 10,
                        formatter: function (params) {
                            const NumberConvert = formatNumber(params.value)
                            return NumberConvert

                        },
                        "textStyle": {
                            "color": "#fff"
                        }
                    }
                },
                emphasis: {
                    focus: 'series'
                },
                // data: [29.12, 25, 360.09, 295.64,119.47],
                data: sortedData?.map(item => ({
                    value: item.VALUE, 
                    ...item
                })),
                type: 'bar',
                barWidth: "80%",
                color: '#417695',
                itemStyle: {
                    normal: {
                        barBorderRadius: [3, 3, 3, 3],
                        color: '#417695',
                    }
                }

            }
        ]
    };

    const memoizedChartOption = useMemo(() => SchoolDistrictEmployeesnew, [sortedData]);


    const MyChart = React.memo(({ options }) => {
        return <ReactEcharts option={options} notMerge={true} lazyUpdate={true} style={{ width: '100%', height: screenWidth <= 1450 && screenWidth >= 1100 ? 200 : 210 }} />;
    });
    return (
        <div className=" h-[100%]">

            <div className="bg-[#0F0D0B] text-[#fff] h-[100%] rounded-[7px]">
                <div className="relative h-[190px]">
                    <div className=" h-[180px] ">
                        <img src={SchoolDistBannerImg} className="h-[190px] w-full " />
                    </div>
                    <div className="w-full absolute bottom-0 h-[40px] bg-[#0f0d0bb3] py-2 px-3">
                        <h3 className="text-[16.2px] text-[#fff]">School District Employees</h3>
                    </div>

                </div>
                <LoaderContainer height={"70px"} width={"100%"} loading={Total_Teacher_FTEloading} className="mt-2 mb-2">

                    <div className="grid grid-cols-1 gap-10 px-5 mt-5">
                        <div className="flex items-start gap-4">
                            <img src={InterviewImg} className="h-[38px] w-[38px]" />
                            <div className="pt-2">
                                {/* <p className="text-[9.2px] text-[#ebebeb] font-light opacity-80 mb-1">Total Teachers</p> */}
                                <p className="text-[14px] text-[#ebebeb] font-light opacity-80 mb-1">Total Teacher Count</p>
                                {/* <h4 className="text-[20px] text-[#fff]">829.32</h4> */}
                                {/* <h4 className="text-[20.2px] text-[#fff]">{convertIntoCommaSeperated(Math.round(totalValue))}</h4> */}
                                <h4 className="text-[16px] font-semibold text-[#fff]">{convertIntoCommaSeperated(Total_Teacher_FTE?.[0]?.VALUE)}</h4>
                            </div>
                        </div>


                    </div>
                </LoaderContainer>
                <LoaderContainer height={"220px"} width={"100%"} loading={TeacherFTEloadingdata} className="mt-2 mb-2">
                    <div className="border-t border-[#ffffff26]">
                        <div className="px-2 mt-5">

                            <div className="flex justify-between">
                                <p className="text-[14.2px] text-[#ebebeb] font-light  mb-1"> Teachers</p>
                                {/* <p className="text-[9.2px] text-[#ebebeb] font-light mb-1"> Administrators</p> */}
                            </div>
                        </div>

                    </div>


                    <div className="px-2 mt-1">
                        <MyChart options={memoizedChartOption} />

                        {/* <ReactEcharts option={SchoolDistrictEmployeesnew} style={{ width: screenWidth <= 1450 && screenWidth >= 1100 ? 240 : 280, height: screenWidth <= 1450 && screenWidth >= 1100 ? 200 : 210 }} /> */}
                    </div>
                </LoaderContainer>
                <div className="border-t border-[#ffffff26]">
                    <LoaderContainer height={"60px"} width={"100%"} loading={StudentCounselorRatioloadingdata || StudentTeacherRatioloadingdata} className="mt-2 mb-2">

                        <div className="grid grid-cols-2 gap-10 px-5 mt-8">
                            <div className="flex items-start gap-3">

                                <div className="">
                                    <p className="text-[14px] text-[#ebebeb] font-light opacity-80 mb-1">Student/ Teacher Ratio</p>
                                    <h4 className="text-[16px] font-semibold text-[#fff]">{TeacherRatio}</h4>

                                </div>

                            </div>
                            <div className="flex items-start gap-3">
                                <div className="">
                                    <p className="text-[12.2px] text-[#ebebeb] font-light opacity-80 mb-2">
                                        Student/ Counselor Ratio</p>
                                    <h4 className="text-[16px] font-semibold text-[#fff]">{CounselorRatio}</h4>
                                    {/* <h4 className="text-[20px] text-[#fff]">377:1</h4> */}
                                </div>
                            </div>
                        </div>
                    </LoaderContainer>
                </div>
            </div>
        </div>
    )
}
